// copied from https://github.com/zeit/swr/issues/110#issuecomment-552637429

import { useState, useEffect } from 'react'

/**
 * @template T
 * @param {T} value
 * @param {number} delay
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useDebounce/index.js